import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import { services } from "../config";
import { useAuth } from "./useAuth";
import queryString from "query-string";

export default function AuthService() {
  try {
    const switchBranchInCompany = async payload => {
      let response = await fetch(
        `${payload.backendUrl}/api/auth/switch-branch`,
        {
          method: "POST",
          headers: {
            Accept: "Application/json",
            "Content-Type": "Application/json",
          },
          credentials: "include",
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        response = await response.json();
        throw new Error(response.message);
      }

      const { data } = await response.json();
      return data;
    };

    const switchBranchInCompanyMutation = useMutation(
      payload => switchBranchInCompany(payload),
      {
        onSuccess: data => {},
        onError: err => {
          toast.error(`${err?.message || ""}`);
        },
      }
    );

    return {
      switchBranchInCompanyMutation,
    };
  } catch (err) {
    console.log(err);
  }
}
